import Image from "next/image"
export default function Logo() {
    return (
        <Image src="/img/main-logo.svg" alt="logo" width={125} height={40} />
    )
}